import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import AccountingPosa from './AccountingPosa';

interface Paths {
  accounting: string;
}

const paths: Paths = {
  accounting: '/accounting',
};

export default [
  <RouteIfRights
    component={AccountingPosa}
    exact
    key={paths.accounting}
    modules="account.omni.accounting"
    path={paths.accounting}
    rights="accounting"
  />,
];
